export default "__VITE_ASSET__DlxjXgzG__"